import { SearchPageTemplateSections } from "@/monarch/rules/searchPageTemplate/types";
import { ConfigureProps } from "react-instantsearch";

export interface SearchProps {
  variant?: "default";
  searchConfig?: ConfigureProps;
  searchIndex?: string;
  children?: React.ReactNode;
  query_string?: string;
  results_title?: string;
}

export type UiState = {
  [indexName: string]: {
    refinementList?: {
      [facet: string]: string[];
    };
    page?: number;
    query?: string;
  };
};

export type SearchResult = {
  title: string;
  partner: string[];
  partner_keys: string[];
  product_source: string;
  primary_description: string;
  secondary_description: string;
  tertiary_description: string;
  tags: string[];
  availability: string[];
  subject: string[];
  level: string[];
  language: string[];
  product: string;
  program_type: unknown[];
  staff: unknown[];
  allowed_in: string[];
  blocked_in: string[];
  subscription_eligible: boolean | null;
  subscription_prices: unknown[];
  learning_type: string[];
  learning_type_exp: string[];
  translation_languages: {
    code: string;
    label: string;
    enabled: boolean;
  }[];
  availability_rank: number;
  recent_enrollment_count: number;
  value_per_click_usa: number;
  value_per_click_international: number;
  value_per_lead_usa: number;
  value_per_lead_international: number;
  marketing_url: string;
  card_image_url: string;
  uuid: string;
  weeks_to_complete: number;
  max_effort: number;
  min_effort: number;
  organization_short_code_override: string;
  organization_logo_override: string;
  meta_title: string | null;
  display_on_org_page: boolean;
  external_url: string;
  active_run_key: string;
  active_run_start: number;
  active_run_type: string;
  owners: {
    key: string;
    logoImageUrl: string;
    name: string;
  }[];
  course_titles: string[] | null;
  skills: {
    skill: string;
    category: string;
    subcategory: string;
  }[];
  contentful_fields: {
    page_title: string;
    excluded_from_search: boolean;
    excluded_from_seo: boolean;
    subheading: string;
    hero_text_list: string;
  };
  product_key: string;
  product_marketing_video_url: string | null;
  _geoloc: {
    lat: number;
    lng: number;
  };
  objectID: string;
  _highlightResult: unknown;
  __position: number;
  __queryID: string;
};

export enum FilterVersion {
  VerticalFilterV1 = "verticalFilterv1",
  VerticalFilterV2 = "verticalFilterv2",
  HorizontalFilter = "horizontalFilterV1",
}

export enum SearchVersion {
  HorizontalFilterV1 = "horizontalFilterV1",
  VerticalFilterV1 = "verticalFilterV1",
  VerticalFilterV2 = "verticalFilterV2",
}

export type FilterItemSortingStrategy =
  | "alphabetical"
  | "count"
  | "levelPriority"
  | "availabilityPriority";

export type WeekRangeObj = {
  startWeek: number;
  endWeek: number;
};

export type RefinementItem = {
  isRefined: boolean;
  value: string;
  label: string;
  count: number;
};

export type SearchModule = {
  key: SearchPageTemplateSections;
  renderer: () => React.ReactNode;
};
